/* PB: Subcollection horizontal menu — init + zachování scrollu mezi prokliky */
document.addEventListener("DOMContentLoaded", function () {
  var scrollContainer = document.querySelector('.subcollection-scroll');
  if (!scrollContainer) return;

  // Spustit jen pokud je obsah širší než viewport
  if (scrollContainer.scrollWidth <= scrollContainer.clientWidth + 1) return;

  // Unikátní klíč podle typu menu (muži/ženy)
  var menuKey = 'subcollectionScrollLeft_' + (scrollContainer.dataset.menuType || 'default');
  var savedScroll = sessionStorage.getItem(menuKey);
  if (savedScroll !== null) {
    scrollContainer.scrollLeft = parseInt(savedScroll, 10);
  }
  var links = scrollContainer.querySelectorAll('a');
  links.forEach(function(link) {
    link.addEventListener('click', function() {
      sessionStorage.setItem(menuKey, scrollContainer.scrollLeft);
    });
  });
});